var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPositiveCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 382.849,
    height: 63.675,
    viewBox: "0 0 382.849 63.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.185,
    y1: 1.18,
    x2: 0.815,
    y2: 0.393,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a96903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#aa6a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#b07102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#b97d02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c78e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#daa401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#f0be00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a96903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.423,
    y1: -5.972,
    x2: 1.438,
    y2: 7.076,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.638,
    y1: -7.482,
    x2: 1.222,
    y2: 5.566,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.853,
    y1: -8.992,
    x2: 1.007,
    y2: 4.056,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_103",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 103",
    transform: "translate(-3306.176 580.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_102",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 102",
    transform: "translate(3306.176 -580.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_95",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 95",
    d: "M3322-546.662a48.982,48.982,0,0,1-15.4-2.541l-.423-.14.841-2.539.423.14a46.324,46.324,0,0,0,14.563,2.4c12.3,0,13.629-4.127,13.629-5.9,0-3.4-4.071-4.17-13.2-4.624-7.08-.318-15.894-.714-15.894-7.691,0-5.039,5.136-7.928,14.092-7.928a70.23,70.23,0,0,1,14.256,1.591l.435.1-.577,2.611-.435-.1a67.381,67.381,0,0,0-13.68-1.528c-7.257,0-11.418,1.915-11.418,5.254,0,4.095,5.783,4.681,13.344,5.02,7.743.385,15.746.782,15.746,7.295C3338.306-552.659,3336.717-546.662,3322-546.662Z",
    transform: "translate(-3306.176 577.744)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_96",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 96",
    d: "M3927.087-545.054c-11.415,0-16.731-3.746-16.731-11.788v-15.737h2.674v15.737c0,6.388,4.2,9.114,14.057,9.114s14.061-2.726,14.061-9.114v-15.737h2.674v15.737C3943.823-548.8,3938.5-545.054,3927.087-545.054Z",
    transform: "translate(-3641.083 576.135)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_97",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 97",
    d: "M3435.645-550.776v-22.589l-16.994,19.7-17-19.7v22.589h-2.674v-29.781l19.673,22.8,19.668-22.8v29.782Z",
    transform: "translate(-3357.618 580.558)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_98",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 98",
    d: "M3524.344-573.082l-16.027,24.41-2.235-1.468,18.262-27.814,18.263,27.814-2.236,1.468Z",
    transform: "translate(-3416.987 579.114)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_99",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 99",
    d: "M3618.054-559.071h10.54c5.513,0,8.192-2.086,8.192-6.379,0-4.406-2.61-6.457-8.214-6.457H3609.59v24.444h-2.674v-27.118h21.656c9,0,10.888,4.966,10.888,9.132,0,3.381-1.412,9.053-10.866,9.053h-1.837l11.25,7.636-1.5,2.213Z",
    transform: "translate(-3472.881 577.245)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_151",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 151",
    width: 30.516,
    height: 2.674,
    transform: "translate(174.762 2.665)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_152",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 152",
    width: 2.674,
    height: 26.226,
    transform: "translate(188.683 3.556)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_100",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 100",
    d: "M3825.317-545.349v-27.027h2.674v24.352h25.292v2.674Z",
    transform: "translate(-3593.944 576.023)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_153",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 153",
    width: 2.675,
    height: 39.874,
    transform: "translate(312.566 4.732) rotate(-49.475)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_154",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 154",
    width: 39.874,
    height: 2.675,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 312.567, 28.611)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_155",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 155",
    width: 28.437,
    height: 2.674,
    transform: "translate(354.413 2.665)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_156",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 156",
    width: 28.437,
    height: 2.674,
    transform: "translate(354.413 15.333)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_157",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 157",
    width: 28.437,
    height: 2.674,
    transform: "translate(354.413 28.002)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_101",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 101",
    d: "M3455.617-453.319l-6.257-4.949v4.949H3447.9v-11.724h5.392c2.584,0,4.189,1.313,4.189,3.426,0,2.172-1.5,3.418-4.12,3.418h-1.711l6.294,4.879Zm-2.256-6.255c.982,0,2.63-.265,2.63-2.042,0-1.851-1.839-2.051-2.63-2.051h-4v4.093Z",
    transform: "translate(-78.56 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_102",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 102",
    d: "M3476.764-453.319v-11.724h9.155v1.368h-7.7v3.347l5.741,0v1.354h-5.741v4.27h7.7v1.381Z",
    transform: "translate(-94.559 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_103",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 103",
    d: "M3506.761-466.527l6.572,12.406h-1.606l-1.47-2.829h-7.044l-1.509,2.83h-1.634Zm2.806,8.269-2.819-5.376-2.845,5.376Z",
    transform: "translate(-107.479 -63.209)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_104",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 104",
    d: "M3534.451-453.319v-11.724h1.461l-.006,10.344h7v1.38Z",
    transform: "translate(-126.537 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_105",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 105",
    d: "M3572.289-453.319v-11.724h9.154v1.368h-7.7v3.347l5.741,0v1.354h-5.741v4.27h7.7v1.381Z",
    transform: "translate(-147.511 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_106",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 106",
    d: "M3602.348-453.344a9.98,9.98,0,0,1-5.158-1.382l-.2-.125.8-1.159.18.11a8.691,8.691,0,0,0,4.367,1.183h.093c1.916-.024,3.107-.757,3.11-1.912,0-1-.59-1.427-2.64-1.912l-1.579-.371c-2.554-.6-3.7-1.593-3.713-3.233-.016-1.855,1.782-3.12,4.474-3.147h.079a8.4,8.4,0,0,1,4.376,1.237l.193.122-.774,1.167-.184-.116a6.659,6.659,0,0,0-3.5-1.038h-.1c-1.918.033-3.056.705-3.043,1.8.011.916.74,1.443,2.6,1.879l1.64.381c2.588.6,3.649,1.533,3.662,3.222a2.757,2.757,0,0,1-.814,2,5.349,5.349,0,0,1-3.818,1.3Z",
    transform: "translate(-161.205 -63.894)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_107",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 107",
    d: "M3627.538-453.319v-10.344h-4.3l-.008-1.38h10.044v1.38H3629v10.344Z",
    transform: "translate(-175.751 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_108",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 108",
    d: "M3651.829-466.527l6.573,12.406H3656.8l-1.471-2.829h-7.044l-1.508,2.83h-1.634Zm2.806,8.269-2.818-5.376-2.845,5.376Z",
    transform: "translate(-187.893 -63.209)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_109",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 109",
    d: "M3678.147-453.319v-10.344h-4.3l-.007-1.38h10.044v1.38h-4.283v10.344Z",
    transform: "translate(-203.805 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_110",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 110",
    d: "M3702.294-453.319v-11.724h9.155v1.368h-7.7v3.347l5.741,0v1.354h-5.741v4.27h7.7v1.381Z",
    transform: "translate(-219.575 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_111",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 111",
    d: "M3742.9-453.328v-11.723l4.05-.008c3.96,0,6.608,2.366,6.608,5.887,0,3.5-2.655,5.844-6.607,5.844Zm1.456-1.368,2.593,0c3.225,0,5.15-1.675,5.15-4.473,0-2.817-1.926-4.5-5.151-4.512l-2.592,0Z",
    transform: "translate(-242.083 -64.023)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_112",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 112",
    d: "M3778.951-453.365a6.084,6.084,0,0,1-6.238-6.057,6.092,6.092,0,0,1,6.238-6.073,6.1,6.1,0,0,1,6.26,6.073A6.1,6.1,0,0,1,3778.951-453.365Zm0-10.73a4.678,4.678,0,0,0-4.78,4.674,4.667,4.667,0,0,0,4.78,4.652,4.68,4.68,0,0,0,4.8-4.652A4.636,4.636,0,0,0,3778.948-464.095Z",
    transform: "translate(-258.609 -63.781)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_113",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 113",
    d: "M3817.406-453.318l-7.844-9.446v9.446H3808.1v-11.721h1.354l7.856,9.468v-9.471h1.456v11.725Z",
    transform: "translate(-278.225 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_114",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 114",
    d: "M3840.839-453.319v-11.724h9.155v1.368h-7.7v3.347l5.741,0v1.354h-5.741v4.27h7.7v1.381Z",
    transform: "translate(-296.372 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_115",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 115",
    d: "M3884.657-453.344a9.981,9.981,0,0,1-5.158-1.382l-.2-.125.8-1.159.18.11a8.687,8.687,0,0,0,4.367,1.183h.093c1.915-.024,3.106-.757,3.108-1.912,0-1-.589-1.427-2.64-1.912l-1.579-.371c-2.554-.6-3.7-1.593-3.713-3.233-.016-1.855,1.782-3.12,4.474-3.147h.079a8.4,8.4,0,0,1,4.375,1.237l.193.122-.773,1.167-.184-.116a6.662,6.662,0,0,0-3.5-1.038h-.1c-1.919.033-3.057.705-3.043,1.8.011.916.74,1.443,2.6,1.879l1.64.381c2.588.6,3.649,1.533,3.662,3.222a2.755,2.755,0,0,1-.813,2,5.35,5.35,0,0,1-3.819,1.3Z",
    transform: "translate(-317.694 -63.894)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_116",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 116",
    d: "M3910.3-461.943v8.626h-1.456v-11.721h1.369l4.946,9.316,4.984-9.317h1.346v11.721h-1.456v-8.616l-4.864,9.085Z",
    transform: "translate(-334.07 -64.034)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_117",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 117",
    d: "M3948.53-466.527l6.573,12.406H3953.5l-1.471-2.829h-7.043l-1.509,2.83h-1.634Zm2.806,8.269-2.818-5.376-2.845,5.376Z",
    transform: "translate(-352.358 -63.209)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_118",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 118",
    d: "M3983.938-453.319l-6.257-4.949v4.949h-1.461v-11.724h5.392c2.584,0,4.189,1.313,4.189,3.426,0,2.172-1.5,3.418-4.12,3.418h-1.711l6.294,4.879Zm-2.255-6.255c.981,0,2.629-.265,2.629-2.042,0-1.851-1.839-2.051-2.629-2.051h-4v4.093Z",
    transform: "translate(-371.416 -64.032)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_119",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 119",
    d: "M4006.242-453.319v-10.344h-4.3l-.007-1.38h10.044v1.38H4007.7v10.344Z",
    transform: "translate(-385.673 -64.032)",
    fill: "#161615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPositiveCenter);
export default __webpack_public_path__ + "static/media/logo_positive_center.67684921ee126236da68e9b04d1dd6e0.svg";
export { ForwardRef as ReactComponent };